import React from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  FdpInvoiceActionStatus,
  RatecardFdpInvoiceResponse,
} from "../../../../app/models/responseModels/FdpInvoiceResponses";

interface FdpInvoiceActionMenuProps {
  invoice: RatecardFdpInvoiceResponse | undefined;
  handleAction: CallableFunction;
  handleEdit: CallableFunction;
  handleFlag?: CallableFunction;
  handleActionWithComment: CallableFunction;
}

const FdpInvoiceActionMenu = ({
  invoice,
  handleAction,
  handleEdit,
  handleActionWithComment,
  handleFlag,
}: FdpInvoiceActionMenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [selectedAction, setSelectedAction] = React.useState<string>("");
  const open = Boolean(anchorEl);

  const allActionsDisabled =
    invoice?.fdpInvoiceActions?.every((action) => !action.enabled) ?? true;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedAction("");
  };

  const handleSubmitReview = () => {
    if (selectedAction === "edit") {
      handleEdit();
    } else {
      const hasCommentRequired = invoice?.fdpInvoiceActions.some(
        (action) =>
          selectedAction === action.statusKey && action.commentRequired === true
      );
      if (hasCommentRequired) {
        handleActionWithComment(selectedAction);
      } else {
        handleAction(selectedAction);
      }
    }
    handleClose();
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAction(event.target.value);
  };

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Button
        variant="outlined"
        size="small"
        onClick={handleClick}
        disabled={allActionsDisabled}
      >
        Actions
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        sx={{ mt: -2 }}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: 180,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" pl={1}>
            Provide Review
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <RadioGroup value={selectedAction} onChange={handleRadioChange}>
  {invoice?.fdpInvoiceActions
    ?.filter((action: FdpInvoiceActionStatus) => action.enabled) // Only enabled actions
    .map((action: FdpInvoiceActionStatus) => (
      <MenuItem key={action.statusKey} sx={{ py: 0 }}>
        <FormControlLabel
          value={action.statusKey}
          control={<Radio size="medium" />}
          disabled={!action.enabled}
          label={
            <Typography variant="body2">
              {action.action === "Flag for Ops"
                ? "Comment"
                : action.action === "Fin Accept"
                ? "Approve"
                : action.action}
            </Typography>
          }
        />
      </MenuItem>
    ))}
</RadioGroup>

        <Box sx={{ display: "flex", justifyContent: "flex-end", pr: 1 }}>
          <Button
            size="small"
            disabled={!selectedAction}
            variant="contained"
            onClick={handleSubmitReview}
          >
            Submit
          </Button>
        </Box>
      </Menu>
    </Box>
  );
};

export default FdpInvoiceActionMenu;
